import { uid } from 'uid';
import notFoundIcon from '@assets/svg/icon/not-found.svg';

import {
  badNetTitle,
  websocketsAreUnstableMsg,
  newToastMessageType,
  removeToastMessageType,
  setRemovingToastMessageType,
  updateToastMessageType,
} from '../ToastMessagesConstants';

export function newToastMessage(data, type = newToastMessageType) {
  return (dispatch) => {
    const messageId = uid();
    const action = {
      type,
      data: {
        ...data,
        id: messageId,
      },
    };

    dispatch(action);

    return messageId;
  }
}

export function newToastMessageAsync(...args) {
  return (dispatch) => {
    dispatch(newToastMessage(...args));

    return new Promise((res) => setTimeout(res, 300));
  }
}

export function removeToastMessage(id) {
  return {
    type: removeToastMessageType,
    id,
  };
}

export function setRemovingToastMessage (id) {
  return {
    type: setRemovingToastMessageType,
    id,
  };
}

export function setRemovingToastMessageAsync(id) {
  return (dispatch) => {
    dispatch(setRemovingToastMessage(id));

    return new Promise((res) => setTimeout(res, 300));
  }
}

export function updateToastMessage (id, data) {
  return {
    type: updateToastMessageType,
    data,
    id,
  };
}

export function websocketsAreUnstableToastMessage () {
  return newToastMessage({
    title: badNetTitle,
    content: websocketsAreUnstableMsg,
    iconId: notFoundIcon.url,
  });
}
